module.exports = __webpack_public_path__ + "img/plug_offline.b91dd65e.png";